export default __webpack_public_path__ + "static/media/enghien02.5f99f32b.jpg";